<template>
<div class="container mt-4">
  <b-row v-if="!product">
      <b-col>
          <b-alert show variant="danger"> No product not found. </b-alert>
      </b-col>
  </b-row>
  <b-row v-if="loading">
      <b-col>
          <b-alert show variant="info" > Loading.... </b-alert>
      </b-col>
  </b-row>
  <h3 v-if="product">{{product.Name}}</h3>
  <b-row v-if="product">
    <b-col>
      <b-card :img-src="selectedImageLink || './static/NoImage.jpg'"
              img-alt="Img"
              img-top>
              
              <b-row class="mb-2">
                <b-col>
                  <b-img class="mr-1" v-for="(image) in product.Images" v-bind:key="image.Oid" thumbnail fluid :src="image.ImageLink" alt="Thumbnail" width="100" height="100" v-on:click="SelectImage(image.ImageLink)" />
                </b-col>
              </b-row>
              
              <h2 class="mb-2" v-if="ShowPrices">{{product.Price | toCurrency}}</h2>
              <div class="card-text" v-if="product.FullBoxQty > 0">
                  Full Box Quantity: {{product.FullBoxQty}}
              </div>
              
              <div class="card-text" v-if="product.Description">
                  <div v-for="(line, lineIndex) in product.Description.split('\n')" v-bind:key="lineIndex">{{line}}<br></div>
              </div>
              <div class="card-text" v-else>
                  No Description
              </div>
          <div slot="footer">
              <b-input-group prepend="Add">
                <b-form-input type="number" v-model="product.Qty"></b-form-input>
                <b-btn variant="success" slot="append" v-on:click="addProductToCart" :disabled="!ProductQtyValid">
                  Add To Cart
                </b-btn>
              </b-input-group>
              <b-form-text v-if="!ProductMeetsMin">Minimum order quantity is {{product.QuantityMin}}</b-form-text>
              <b-form-text v-if="!ProductMeetsStepSize">Must order in multiples of {{product.QuantityStepSize}}</b-form-text>
              <b-form-text v-if="!ProductMeetsMax">Maximum order quantity is {{product.QuantityMax}}</b-form-text>
          </div>
      </b-card>
    </b-col>
  </b-row>
    
      
    
</div>
</template>

<script>
import ProductService from "../services/ProductService";
import _ from 'lodash';

import ShowPrices from '@/mixins/ShowPrices';

function GetProduct(number, done) {
  ProductService.GetByItemNumber(number)
    .then(response => {
      if (response.data.length > 0) {
        done(null, response.data[0]);
      } else {
        done("unable to get product");
      }
    })
    .catch(() => {
      done("unable to get product");
    });
}

export default {
  name: "ProductDetail",
  props: ["itemNumber"],
  data() {
    return {
      product: null,
      error: null,
      loading: true,
      selectedImageLink: null,
    };
  },
  // computed: {
  //    ShowPrices() {
  //     return !(_.find(this.$store.state.auth.roles, i => _.toUpper(i) === "HIDEPRICES"));
  //   },
  // },
  computed: {
    ProductMeetsMin(){
      if(this.product.Qty > 0 && this.product.QuantityMin > 0) {
        return this.product.Qty >= this.product.QuantityMin;
      }
      return true;
    },
    ProductMeetsMax(){
      if(this.product.Qty > 0 && this.product.QuantityMax > 0) {
        return this.product.Qty <= this.product.QuantityMax;
      }
      return true;
    },
    ProductMeetsStepSize(){
      if(this.product.Qty > 0 && this.product.QuantityStepSize > 0) {
        return this.product.Qty % this.product.QuantityStepSize == 0;
      }
      return true;
    },
    ProductQtyValid() {
        if(!this.ProductMeetsMin || 
          !this.ProductMeetsMax || 
          !this.ProductMeetsStepSize) {
            return false;
        }
        return true;
    },
  },
  beforeRouteEnter(to, from, next) {
    GetProduct(to.query.number, (err, product) => {
      next(vm => vm.setData(err, product));
    });
  },
  beforeRouteUpdate(to, from, next) {
    this.product = null;
    GetProduct(to.query.number, (err, product) => {
      this.setData(err, product);
      next();
    });
  },
  methods: {
    setData(err, product) {
      if (err) {
        this.error = err.toString();
      } else {
        this.product = product;
        this.selectedImageLink = product.ImageLink;
      }
      this.loading = false;
    },
    addProductToCart() {
      this.$store.commit("AddToCart", this.product);
      var productname = this.product.Name || this.product.ItemNumber;
      this.$toasted
        .success("Added " + this.product.Qty + " X " + productname + " to Cart")
        .goAway(3000);
    },
    SelectImage(link) {
      this.selectedImageLink = link;
    }
  },
  mixins: [ ShowPrices ]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.img-thumbnail:hover {
  cursor: pointer;
  background-color: #dee2e6;
}

.card-img-top{
  height: 15vw;
  object-fit: scale-down;
}

</style>



// WEBPACK FOOTER //
// src/components/productdetail.vue